export interface FileInputOptions {
  multiple?: boolean
  accept?: string
  onFilesSelected?: (files: FileList) => void
}

export const createAndTriggerFileInput = (options: FileInputOptions = {}): void => {
  const { multiple = true, accept = 'image/*', onFilesSelected } = options

  const fileInput = document.createElement('input')
  fileInput.type = 'file'
  fileInput.multiple = multiple
  fileInput.accept = accept
  fileInput.style.display = 'none'

  fileInput.onchange = (event) => {
    const files = (event.target as HTMLInputElement).files
    if (files && files.length > 0) {
      onFilesSelected?.(files)
    }
  }

  document.body.appendChild(fileInput)
  fileInput.click()
  document.body.removeChild(fileInput)
}

export const createAndTriggerPluploadFileInput = (options: Omit<FileInputOptions, 'onFilesSelected'> = {}): void => {
  createAndTriggerFileInput({
    ...options,
    onFilesSelected: (files) => {
      if ((window as any).pluploadInstance) {
        Array.from(files).forEach((file) => {
          ;(window as any).pluploadInstance.addFile(file)
        })
        ;(window as any).pluploadInstance.start()
      }
    },
  })
}
